import type { RouteRecordRaw } from 'vue-router'
import { HelmPermission } from '@helm/services/api/client'

const users: readonly RouteRecordRaw[] = [
    {
        path: `/users`,
        component: () => import('@helm/pages/Users/ListUsers.vue'),
        name: `users`,
        meta: {
            props: {
                sideNav: `users`
            },
            roles: [HelmPermission.HELM_USER_READ]
        }
    },
    {
        path: `/users/:id`,
        component: () => import('@helm/pages/Users/ViewUser.vue'),
        name: `users.view`,
        meta: {
            props: {
                sideNav: `users`
            },
            roles: [HelmPermission.HELM_USER_READ]
        }
    },
    {
        path: `/roles/:id(\\d+|new)?`,
        component: () => import('@helm/pages/Users/ListRoles.vue'),
        name: `users.roles`,
        meta: {
            props: {
                sideNav: `users`
            },
            roles: [HelmPermission.HELM_USER_READ]
        }
    },
    {
        path: `/sso`,
        component: () => import('@helm/pages/Config/SSO.vue'),
        name: `users.sso`,
        meta: {
            props: {
                sideNav: `users`
            },
            roles: [HelmPermission.HELM_CONFIG, HelmPermission.HELM_USER_READ]
        }
    }
]

export default users
